import {
  RECEIVE_SIGNME_REGISTRATION_STATUS,
  RECEIVE_ESIGNATURE_DATA,
  REQUEST_DOCUMENT_ESIGNATURE,
  COMPLETE_PREVIEW_QES,
  RESET_SIGNME_REGISTRATION_STATUS,
  RESET_DOCUMENT_ESIGNATURE_STATUS,
  SET_SIGNME_IDENTITY_ID,
  RECEIVE_FINALISED_PDF_DATA,
  REQUEST_FINALISE_PDF_DOC,
  SET_ERROR_ON_FINALISE_PDF_DOC,
  SET_ATRUST_SHORT_TERM,
  CLEAR_ATRUST_SHORT_TERM
} from '../actions/esignature';
import { mapUpdateProperty } from '../../components/helpers/immutable';

const esignature = (state, action) => {
  switch (action.type) {
    case SET_ATRUST_SHORT_TERM:
      return {
        ...state,
        atrustShortTerm: action.payload
      };
    case CLEAR_ATRUST_SHORT_TERM:
      return {
        ...state,
        atrustShortTerm: null
      };
    case REQUEST_FINALISE_PDF_DOC:
      return Object.assign({}, state, {
        isFetching: true,
        finalisePdfDocError: false
      });

    case SET_ERROR_ON_FINALISE_PDF_DOC:
      return Object.assign({}, state, {
        isFetching: false,
        finalisePdfDocError: action.payload
      });

    case RECEIVE_FINALISED_PDF_DATA: {
      return {
        ...state,
        isFetching: false,
        requestedDocuments: mapUpdateProperty(
          state.requestedDocuments,
          action.payload.id,
          {
            finalised: true,
            attachment: action.payload.pages
          }
        )
      };
    }
    case RECEIVE_SIGNME_REGISTRATION_STATUS:
      return {
        ...state,
        registrationStatus: action.payload
      };
    case RESET_SIGNME_REGISTRATION_STATUS:
      return {
        ...state,
        registrationStatus: ''
      };
    case RESET_DOCUMENT_ESIGNATURE_STATUS:
      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.payload]: {}
        }
      };
    case REQUEST_DOCUMENT_ESIGNATURE:
      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.payload.docId]: {
            internalCallbackId: action.payload.internalCallbackId
          }
        }
      };
    case SET_SIGNME_IDENTITY_ID:
      return {
        ...state,
        signmeIdentityId: action.payload
      };

    case RECEIVE_ESIGNATURE_DATA: {
      let docId = '';

      for (const [documentId, signature] of Object.entries(state.signatures)) {
        if (
          signature.internalCallbackId === action.payload.internalCallbackId
        ) {
          docId = documentId;
        }
      }
      if (!docId) return state;

      const success = action.payload.signedDocumentIds?.includes(docId);
      const fail = action.payload.failedDocumentIds?.includes(docId);

      if (!success && !fail) return state;

      return {
        ...state,
        requestedDocuments: mapUpdateProperty(state.requestedDocuments, docId, {
          qualifiedSigned: success
        }),
        signatures: {
          ...state.signatures,
          [docId]: {
            success: success,
            fail: fail,
            postSigningPages:
              success &&
              Array.isArray(action.payload.postSigningPages) &&
              action.payload.postSigningPages.find(i => i.documentId === docId)
          }
        }
      };
    }

    case COMPLETE_PREVIEW_QES: {
      if (!window.previewMode) {
        return state;
      }
      const docId = action.payload?.docId;
      if (!docId) {
        return state;
      }
      return {
        ...state,
        requestedDocuments: mapUpdateProperty(state.requestedDocuments, docId, {
          qualifiedSigned: true
        }),
        signatures: {
          ...state.signatures,
          [docId]: {
            success: true,
            fail: false
          }
        }
      };
    }

    default:
      return state;
  }
};
export default esignature;
